import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/vercel/path0/client/components/ui/skeleton.tsx");
